/* CONTROL LANDINGS */
import loaderMain from '@/modules/Landing/instances/loader-main'
import ageMain from '@/modules/Landing/instances/age-main'
import loaderF from '@/modules/Landing/instances/loader-f'
import loaderM from '@/modules/Landing/instances/loader-m'

import loaderFGlp from '@/modules/Landing/instances/loader-f-glp'
import glp1Landing from '@/modules/Landing/instances/glp-1-landing'

import loaderActivity from '@/modules/Landing/instances/loader-activity'
import loaderActivityF from '@/modules/Landing/instances/loader-activity-f'
import loaderActivityM from '@/modules/Landing/instances/loader-activity-m'
import ageActivity from '@/modules/Landing/instances/age-activity'
import ageActivityF from '@/modules/Landing/instances/age-activity-f'
import ageActivityM from '@/modules/Landing/instances/age-activity-m'

import loaderYoga from '@/modules/Landing/instances/loader-yoga'
import loaderYogaF from '@/modules/Landing/instances/loader-yoga-f'
import ageYoga from '@/modules/Landing/instances/age-yoga'
import ageYogaF from '@/modules/Landing/instances/age-yoga-f'

import loaderWalking from '@/modules/Landing/instances/loader-walking'
import loaderWalkingF from '@/modules/Landing/instances/loader-walking-f'
import loaderNordicWalkingF from '@/modules/Landing/instances/loader-nordic-walking-f'
import loaderWalkingFUs from '@/modules/Landing/instances/loader-walking-f-us'
import loaderWalkingJapaneseF from '@/modules/Landing/instances/loader-walking-japanese-f'
import loaderWalkingJapaneseFv2 from '@/modules/Landing/instances/loader-walking-japanese-f-v2'
import loaderTaiChiWalking from '@/modules/Landing/instances/loader-tai-chi-walking'
import loaderTaiChiWalkingF from '@/modules/Landing/instances/loader-tai-chi-walking-f'
import loaderTaiChiWalkingM from '@/modules/Landing/instances/loader-tai-chi-walking-m'
import loaderTaiChiWalkingFPr from '@/modules/Landing/instances/loader-tai-chi-walking-f-pr'
import loaderWalkingM from '@/modules/Landing/instances/loader-walking-m'
import ageWalking from '@/modules/Landing/instances/age-walking'
import ageWalkingF from '@/modules/Landing/instances/age-walking-f'
import ageWalkingFAl from '@/modules/Landing/instances/age-walking-f-al'
import ageNordicWalkingF from '@/modules/Landing/instances/age-nordic-walking-f'
import ageWalkingFUs from '@/modules/Landing/instances/age-walking-f-us'
import agePrintableWalkingF from '@/modules/Landing/instances/age-printable-walking-f'
import ageWalkingJapaneseF from '@/modules/Landing/instances/age-walking-japanese-f'
import ageWalkingJapaneseFv2 from '@/modules/Landing/instances/age-walking-japanese-f-v2'
import ageTaiChiWalking from '@/modules/Landing/instances/age-tai-chi-walking'
import ageTaiChiWalkingF from '@/modules/Landing/instances/age-tai-chi-walking-f'
import ageTaiChiWalkingFPr from '@/modules/Landing/instances/age-tai-chi-walking-f-pr'
import ageTaiChiWalkingPr from '@/modules/Landing/instances/age-tai-chi-walking-pr'
import ageTaiChiWalkingM from '@/modules/Landing/instances/age-tai-chi-walking-m'
import ageWalkingM from '@/modules/Landing/instances/age-walking-m'

import agePilatesF from '@/modules/Landing/instances/age-pilates-f'
import loaderPilatesF from '@/modules/Landing/instances/loader-pilates-f'
import ageBoudoirPilatesF from '@/modules/Landing/instances/age-boudoir-pilates-f'
import loaderBoudoirPilatesF from '@/modules/Landing/instances/loader-boudoir-pilates-f'
import ageChairWorkoutsM from '@/modules/Landing/instances/age-chair-workouts-m'
import ageChairTaiChiM from '@/modules/Landing/instances/age-chair-tai-chi-m'
import ageChairTaiChiF from '@/modules/Landing/instances/age-chair-tai-chi-f'
import ageChairTaiChiPr from '@/modules/Landing/instances/age-chair-tai-chi-pr'
import loaderChairWorkoutsM from '@/modules/Landing/instances/loader-chair-workouts-m'
import loaderChairTaiChiF from '@/modules/Landing/instances/loader-chair-tai-chi-f'
import loaderAsianPilatesF from '@/modules/Landing/instances/loader-asian-pilates-f'
import ageAsianPilatesF from '@/modules/Landing/instances/age-asian-pilates-f'
import ageSeniorPilatesF from '@/modules/Landing/instances/age-senior-pilates-f'

import ageMenopauseF from '@/modules/Landing/instances/age-menopause-f'

import ageCalisthenics from '@/modules/Landing/instances/age-calisthenics'
import ageCalisthenicsM from '@/modules/Landing/instances/age-calisthenics-m'
import ageCalisthenicsF from '@/modules/Landing/instances/age-calisthenics-f'
import loaderCalisthenics from '@/modules/Landing/instances/loader-calisthenics'
import loaderCalisthenicsM from '@/modules/Landing/instances/loader-calisthenics-m'
import loaderCalisthenicsF from '@/modules/Landing/instances/loader-calisthenics-f'

import loaderMilitaryM from '@/modules/Landing/instances/loader-military-m'
import ageMilitaryM from '@/modules/Landing/instances/age-military-m'

import loaderTaiChiYogaM from '@/modules/Landing/instances/loader-tai-chi-yoga-m'
import loaderChairTaiChiM from '@/modules/Landing/instances/loader-chair-tai-chi-m'
import loaderChairTaiChiPr from '@/modules/Landing/instances/loader-chair-tai-chi-pr'
import ageTaiChiYogaM from '@/modules/Landing/instances/age-tai-chi-yoga-m'
import ageTaiChiYogaMAl from '@/modules/Landing/instances/age-tai-chi-yoga-m-al'
import ageTaiChiYogaMPr from '@/modules/Landing/instances/age-tai-chi-yoga-m-pr'
import loaderFMediterraneanDiet from '@/modules/Landing/instances/loader-f-mediterranean-diet'
import loaderFHighProtein from '@/modules/Landing/instances/loader-f-high-protein'
import loaderFRamadan from '@/modules/Landing/instances/loader-f-ramadan'
import loaderFAyurveda from '@/modules/Landing/instances/loader-f-ayurveda'
import loaderTaiChiMGolfers from '@/modules/Landing/instances/loader-tai-chi-m-golfers'
import ageTaiChiMGolfers from '@/modules/Landing/instances/age-tai-chi-m-golfers'
import loaderFAntiInflammatoryDiet from '@/modules/Landing/instances/loader-f-anti-inflammatory-diet'
import loaderCarnivoreDietGs from '@/modules/Landing/instances/loader-carnivore-diet-gs'
import loaderFHashimotoDiet from '@/modules/Landing/instances/loader-f-hashimoto-diet'
import loaderJapaneseDiet from '@/modules/Landing/instances/loader-japanese-diet'

/* DYNAMIC */
import dynamicLoader from '@/modules/Landing/instances/dynamic/dynamic-loader'
import dynamicLoaderMaleDark from '@/modules/Landing/instances/dynamic/dynamic-loader-male-dark'
import dynamicLoaderMaleLight from '@/modules/Landing/instances/dynamic/dynamic-loader-male-light'
import dynamicLoaderFemale from '@/modules/Landing/instances/dynamic/dynamic-loader-female'
import dynamicAge18 from '@/modules/Landing/instances/dynamic/dynamic-age-18-50'
import dynamicAge40 from '@/modules/Landing/instances/dynamic/dynamic-age-40-80'

/* CREATIVES */
import creativesBellytype from '@/modules/Landing/instances/creatives/creatives-bellytype'
import creativesSpreadsheet from '@/modules/Landing/instances/creatives/creatives-spreadsheet'
import creativesCalorieCalculator from '@/modules/Landing/instances/creatives/creatives-calorie-calculator'
import creativesExercise from '@/modules/Landing/instances/creatives/creatives-exercise'
import creativesWeightLoss from '@/modules/Landing/instances/creatives/creatives-weight-loss'
import creativesFasting from '@/modules/Landing/instances/creatives/creatives-fasting'
import creativesDemgen from '@/modules/Landing/instances/creatives/creatives-demgen'
import loaderFCortisolDiet from '@/modules/Landing/instances/loader-f-cortisol-diet'
import creativesSpreadsheetWalking from '@/modules/Landing/instances/creatives/creatives-spreadsheet-walking'
import creativesBestDiet from '@/modules/Landing/instances/creatives/creatives-best-diet'
import loaderFMenopauseDiet from '@/modules/Landing/instances/loader-f-menopause-diet'
import loaderWaterBalanceF from '@/modules/Landing/instances/loader-water-balance-f'
import loaderWaterBalanceM from '@/modules/Landing/instances/loader-water-balance-m'
import creativesDategenFemaleTaiChiWalking from '@/modules/Landing/instances/creatives/creatives-dategen-female-tai-chi-walking'
import creativesDategenFemalePilates from '@/modules/Landing/instances/creatives/creatives-dategen-female-pilates'
import creativesDategenFemale from '@/modules/Landing/instances/creatives/creatives-dategen-female'
import creativesDategenMainWalking from '@/modules/Landing/instances/creatives/creatives-dategen-main-walking'
import creativesDategenFemaleWalking from '@/modules/Landing/instances/creatives/creatives-dategen-female-walking'
import creativesDategenFemaleYoga from '@/modules/Landing/instances/creatives/creatives-dategen-female-yoga'
import creativesSearchWallPilates from '@/modules/Landing/instances/creatives/creatives-search-wall-pilates'
import creativesSearchYoga from '@/modules/Landing/instances/creatives/creatives-search-yoga'
import creativesSearchTaiChiWalkingGs from '@/modules/Landing/instances/creatives/creatives-search-tai-chi-walking-gs'
import creativesSearchTaiChiGs from '@/modules/Landing/instances/creatives/creatives-search-tai-chi-gs'
import creativesFastingGs from '@/modules/Landing/instances/creatives/creatives-fasting-gs'
import dynamicAgeF18 from '@/modules/Landing/instances/dynamic/dynamic-age-f-18-50'
import loaderTaiChiF from '@/modules/Landing/instances/loader-tai-chi-f'
import ageTaiChiF from '@/modules/Landing/instances/age-tai-chi-f'
import ageTaiChi from '@/modules/Landing/instances/age-tai-chi'
import ageTaiChiPr from '@/modules/Landing/instances/age-tai-chi-pr'
import loaderTaiChi from '@/modules/Landing/instances/loader-tai-chi'

export const instances = {
	/* CONTROL LANDINGS */
	'loader-main': loaderMain,
	'age-main': ageMain,
	'loader-f': loaderF,
	'loader-m': loaderM,
	'loader-f-cortisol-diet': loaderFCortisolDiet,
	'loader-f-menopause-diet': loaderFMenopauseDiet,
	'loader-f-glp': loaderFGlp,
	'glp-1-landing': glp1Landing,

	'loader-activity': loaderActivity,
	'loader-activity-f': loaderActivityF,
	'loader-activity-m': loaderActivityM,
	'age-activity': ageActivity,
	'age-activity-f': ageActivityF,
	'age-activity-m': ageActivityM,
	'age-menopause-f': ageMenopauseF,

	'loader-yoga': loaderYoga,
	'loader-yoga-f': loaderYogaF,
	'age-yoga': ageYoga,
	'age-yoga-f': ageYogaF,

	'loader-walking': loaderWalking,
	'loader-walking-f': loaderWalkingF,
	'loader-nordic-walking-f': loaderNordicWalkingF,
	'loader-walking-f-us': loaderWalkingFUs,
	'loader-walking-japanese-f': loaderWalkingJapaneseF,
	'loader-walking-japanese-f-v2': loaderWalkingJapaneseFv2,
	'loader-tai-chi-walking': loaderTaiChiWalking,
	'loader-tai-chi-walking-f': loaderTaiChiWalkingF,
	'loader-tai-chi-walking-m': loaderTaiChiWalkingM,
	'loader-tai-chi-walking-f-pr': loaderTaiChiWalkingFPr,
	'loader-tai-chi-f': loaderTaiChiF,
	'loader-tai-chi': loaderTaiChi,
	'loader-walking-m': loaderWalkingM,
	'age-walking': ageWalking,
	'age-walking-f': ageWalkingF,
	'age-walking-f-al': ageWalkingFAl,
	'age-nordic-walking-f': ageNordicWalkingF,
	'age-walking-f-us': ageWalkingFUs,
	'age-printable-walking-f': agePrintableWalkingF,
	'age-walking-japanese-f': ageWalkingJapaneseF,
	'age-walking-japanese-f-v2': ageWalkingJapaneseFv2,
	'age-tai-chi-walking': ageTaiChiWalking,
	'age-tai-chi-walking-f': ageTaiChiWalkingF,
	'age-tai-chi-walking-f-pr': ageTaiChiWalkingFPr,
	'age-tai-chi-walking-pr': ageTaiChiWalkingPr,
	'age-tai-chi-walking-m': ageTaiChiWalkingM,
	'age-tai-chi-f': ageTaiChiF,
	'age-walking-m': ageWalkingM,
	'loader-f-mediterranean-diet': loaderFMediterraneanDiet,
	'loader-f-anti-inflammatory-diet': loaderFAntiInflammatoryDiet,
	'loader-f-hashimoto-diet': loaderFHashimotoDiet,
	'age-tai-chi': ageTaiChi,
	'age-tai-chi-pr': ageTaiChiPr,

	'age-pilates-f': agePilatesF,
	'loader-pilates-f': loaderPilatesF,
	'age-boudoir-pilates-f': ageBoudoirPilatesF,
	'loader-boudoir-pilates-f': loaderBoudoirPilatesF,
	'age-chair-workouts-m': ageChairWorkoutsM,
	'age-chair-tai-chi-m': ageChairTaiChiM,
	'age-chair-tai-chi-f': ageChairTaiChiF,
	'age-chair-tai-chi-pr': ageChairTaiChiPr,
	'loader-chair-workouts-m': loaderChairWorkoutsM,
	'loader-chair-tai-chi-f': loaderChairTaiChiF,
	'loader-asian-pilates-f': loaderAsianPilatesF,
	'age-asian-pilates-f': ageAsianPilatesF,
	'age-senior-pilates-f': ageSeniorPilatesF,

	'age-calisthenics': ageCalisthenics,
	'age-calisthenics-m': ageCalisthenicsM,
	'age-calisthenics-f': ageCalisthenicsF,
	'loader-calisthenics': loaderCalisthenics,
	'loader-calisthenics-m': loaderCalisthenicsM,
	'loader-calisthenics-f': loaderCalisthenicsF,

	'age-military-m': ageMilitaryM,
	'loader-military-m': loaderMilitaryM,

	'loader-tai-chi-yoga-m': loaderTaiChiYogaM,
	'age-tai-chi-yoga-m': ageTaiChiYogaM,
	'age-tai-chi-yoga-m-al': ageTaiChiYogaMAl,
	'age-tai-chi-yoga-m-pr': ageTaiChiYogaMPr,
	'loader-water-balance-f': loaderWaterBalanceF,
	'loader-water-balance-m': loaderWaterBalanceM,
	'loader-f-high-protein': loaderFHighProtein,
	'loader-f-ramadan': loaderFRamadan,
	'loader-f-ayurveda': loaderFAyurveda,
	'loader-chair-tai-chi-m': loaderChairTaiChiM,
	'loader-chair-tai-chi-pr': loaderChairTaiChiPr,
	'loader-tai-chi-m-golfers': loaderTaiChiMGolfers,
	'age-tai-chi-m-golfers': ageTaiChiMGolfers,
	'loader-carnivore-diet-gs': loaderCarnivoreDietGs,
	'loader-japanese-diet': loaderJapaneseDiet,

	/* DYNAMIC */
	'dynamic-age-18-50': dynamicAge18,
	'dynamic-age-40-80': dynamicAge40,
	'dynamic-age-f-18-50': dynamicAgeF18,
	'dynamic-loader': dynamicLoader,
	'dynamic-loader-male-dark': dynamicLoaderMaleDark,
	'dynamic-loader-male-light': dynamicLoaderMaleLight,
	'dynamic-loader-female': dynamicLoaderFemale,

	/* CREATIVES */
	'creatives-bellytype': creativesBellytype,
	'creatives-spreadsheet': creativesSpreadsheet,
	'creatives-calorie-calculator': creativesCalorieCalculator,
	'creatives-exercise': creativesExercise,
	'creatives-weight-loss': creativesWeightLoss,
	'creatives-fasting': creativesFasting,
	'creatives-spreadsheet-walking': creativesSpreadsheetWalking,
	'creatives-best-diet': creativesBestDiet,
	'creatives-demgen': creativesDemgen,

	'creatives-dategen-female-tai-chi-walking': creativesDategenFemaleTaiChiWalking,
	'creatives-dategen-female-pilates': creativesDategenFemalePilates,
	'creatives-dategen-female': creativesDategenFemale,
	'creatives-dategen-main-walking': creativesDategenMainWalking,
	'creatives-dategen-female-walking': creativesDategenFemaleWalking,
	'creatives-dategen-female-yoga': creativesDategenFemaleYoga,
	'creatives-search-wall-pilates': creativesSearchWallPilates,
	'creatives-search-yoga': creativesSearchYoga,
	'creatives-search-tai-chi-walking-gs': creativesSearchTaiChiWalkingGs,
	'creatives-search-tai-chi-gs': creativesSearchTaiChiGs,
	'creatives-fasting-gs': creativesFastingGs,
}
